let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    /*
     * Chaque abonné est isolé : si l'un d'eux plante (script du thème ou d'une application),
     * l'erreur est journalisée mais n'interrompt plus la suite, par exemple l'ouverture du panier après un ajout.
     */
    const promises = subscribers[eventName].map((callback) => {
      try {
        return Promise.resolve(callback(data)).catch((e) => console.error('[pubsub] ' + eventName, e));
      } catch (e) {
        console.error('[pubsub] ' + eventName, e);
        return Promise.resolve();
      }
    });
    return Promise.all(promises);
  } else {
    return Promise.resolve();
  }
}